"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Account = void 0;
var Account = /** @class */ (function () {
    function Account(address) {
        this.address = address;
    }
    Account.prototype.getAddress = function () {
        return this.address;
    };
    Account.isValidAddress = function (address) {
        return /^[\w\d]{34}$/.test(address);
    };
    Account.ADDRESS_LENGTH = 25;
    return Account;
}());
exports.Account = Account;
